import { useState } from "react";
import { heroStats, siteMeta } from "@/mocks/home";

const primaryHost = "liuli-shrine.com";

export default function Hero() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
    if (navigator.clipboard) {
      navigator.clipboard.writeText(primaryHost).catch(() => undefined);
    }
  };

  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20artistic%20ink%20wash%20texture%20in%20celadon%20green%20and%20warm%20gold%2C%20glazed%20ceramic%20surface%20with%20delicate%20crackle%20lines%2C%20soft%20drifting%20mist%20and%20layered%20depth%2C%20elegant%20oriental%20minimalism%2C%20deep%20moody%20tones%20for%20text%20overlay&width=1920&height=1080&seq=liuli-hero-main-2026&orientation=landscape"
          alt="琉璃神社入口索引主视觉"
          title="琉璃神社最新地址入口索引"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/75"></div>
      </div>

      <div className="relative w-full max-w-[1180px] mx-auto px-4 md:px-8 pt-32 md:pt-40 pb-16 md:pb-20">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/25 bg-white/10 text-white/80 text-xs">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-300"></span>
            最近更新 {siteMeta.updatedAt} · {siteMeta.nextCheck}
          </span>

          <h1 className="mt-6 font-heading font-bold text-white text-3xl md:text-5xl leading-tight max-w-3xl">
            找不到 琉璃神社 官网？
            <br className="hidden sm:block" />
            最新地址与镜像入口都在这里
          </h1>

          <p className="mt-5 text-white/80 text-sm md:text-base leading-relaxed max-w-2xl">
            {siteMeta.intro}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-2xl">
            <div className="flex items-center gap-3 flex-1 min-w-0 px-4 py-3 rounded-md bg-white/10 border border-white/20 backdrop-blur">
              <i className="ri-global-line text-primary-200 text-lg"></i>
              <div className="min-w-0 flex-1">
                <p className="text-[11px] text-white/60 leading-none">当前推荐入口</p>
                <p className="text-sm text-white font-medium truncate mt-1">{primaryHost}</p>
              </div>
              <button
                type="button"
                onClick={handleCopy}
                className="shrink-0 inline-flex items-center gap-1 px-3 py-1.5 rounded-md text-xs whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
              >
                <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
                {copied ? "已复制" : "复制"}
              </button>
            </div>
            <a
              href="#mirrors"
              className="inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-md text-sm whitespace-nowrap cursor-pointer bg-white/20 text-white border border-white/30 hover:bg-white/25 transition-colors"
            >
              <i className="ri-links-line"></i>
              浏览全部镜像
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-px rounded-md overflow-hidden border border-white/20 bg-white/10">
            {heroStats.map((stat) => (
              <div key={stat.id} className="bg-foreground-950/30 px-4 py-4">
                <dt className="text-[11px] text-white/60 tracking-wide">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl md:text-2xl text-white">{stat.value}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}